<i18n lang='yml' src='../i18n/ContainerManagement.yml'></i18n>

<template>
  <div v-if="loading">
    <loading-animation-vue></loading-animation-vue>
  </div>
  <div v-else class="border-bottom">
    <legend> {{ $t('heading') }} </legend>
    <div class="form-group">
      <div v-for="mm in this.mappedMemberships" v-bind:key="mm.id" class="row">
        <div class="col-sm-12">
          <p> {{ mm.name }} </p>
          <input type="hidden" :name='`container[container_membership_limits_attributes][${mm.network_role_id}][id]`' :value="mm.id">
          <input type="hidden" :name='`container[container_membership_limits_attributes][${mm.network_role_id}][network_role_id]`' :value="mm.network_role_id">
        </div>
        <div class="col-sm-12">
          <div class="form-group select-group">
            <fieldset>
              <div class="radio-inline">
                <label>
                  <input type="radio" :name='`container[container_membership_limits_attributes][${mm.network_role_id}][active]`' :value="true" v-model="mm.active">
                  {{ $t('limit') }}
                </label>
              </div>
              <div class="radio-inline">
                <label>
                  <input type="radio" :name='`container[container_membership_limits_attributes][${mm.network_role_id}][active]`' :value="false" v-model="mm.active">
                  {{ $t('no_limit') }}
                </label>
              </div>
            </fieldset>
          </div>
          <div class="form-group">
            <label class="sr-only" :for='`container[container_membership_limits_attributes][${mm.network_role_id}][membership_limit]`'> {{ $t('set_member_limits') }} </label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"> {{ mm.member_count }} / </span>
              </div>
              <input type="number" :id='`container[container_membership_limits_attributes][${mm.network_role_id}][membership_limit]`' :name='`container[container_membership_limits_attributes][${mm.network_role_id}][membership_limit]`' v-model="mm.membership_limit" class="form-control">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props: {
            roles: { type: String }, // [ {id, name_en, name_fr, ... }, ... ]
            limits: { type: String }, // [ { id, container_id, network_role_id, membership_limit }, ... ]
            counts: { type: String }, // { network_role_id => user_count, ... }
        },
        data () {
            return {
                mappedMemberships: {},
                loading: true
            }
        },
        mounted () {
            try {
                this.componentSetup();
            } finally {
                this.loading = false
            }
        },
        methods: {
            componentSetup() {
                var limits = JSON.parse(this.limits);
                var roles = JSON.parse(this.roles);
                var counts = JSON.parse(this.counts);

                var roleMapping = {};
                roles.forEach((item) => {
                    roleMapping[item.id] = item;
                });

                limits.forEach((item) => {
                    const nrid = item.network_role_id;
                    this.mappedMemberships[nrid] = item;
                    this.mappedMemberships[nrid].name = roleMapping[nrid].name_en;
                    this.mappedMemberships[nrid].member_count = counts[nrid.toString()] || 0;
                    this.mappedMemberships[nrid].active = item.active;
                });

                roles.forEach((item) => {
                    if (!this.mappedMemberships.hasOwnProperty(item.id)) {
                        this.mappedMemberships[item.id] = {
                            id: null,
                            network_role_id: item.id,
                            membership_limit: null,
                            name: roleMapping[item.id].name_en,
                            active: false,
                            member_count: counts[item.id.toString()] || 0,
                        };
                    }
                });
            }
        },
    }
</script>
